import SectionHeader from "../Atomics/SectionHeader/SectionHeader";
import {
  VerifiedTooltip,
  UnverifiedTooltip,
} from "../Atomics/CustomCheckTooltips/CustomCheckTooltips";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlayCircle,
  faEllipsisV,
  faCalendarAlt,
} from "@fortawesome/free-solid-svg-icons";
import { baseURL } from "../../api/dataFetcher";

const VideoCardList = ({
  imgAlt = "",
  imgSrc,
  videoTitle,
  videoCategory,
  views,
  timeAgo,
  videoHref = "#",
  time,
  active = null,
  verified = false,
}) => {
  const activeStatus = active
    ? "video-card video-card-list active"
    : "video-card video-card-list";
  const categoryClass = verified
    ? "video-page text-success-custom"
    : "video-page text-danger-custom";
  return (
    <>
      <div
        className={activeStatus}
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div className="video-card-image" style={{ width: "30%" }}>
          <a className="play-icon" href={videoHref}>
            <FontAwesomeIcon icon={faPlayCircle} />
          </a>
          <a href={videoHref}>
            <img
              style={{ objectFit: "cover", height: "100%" }}
              className="img-fluid"
              src={baseURL + imgSrc}
              alt={imgAlt}
            />
          </a>
          {/* <div className="time">{time}</div> */}
        </div>

        <div className="video-card-body" style={{ width: "70%" }}>
          <div className="video-title">
            <a href={videoHref}>{videoTitle}</a>
          </div>
          <div className={categoryClass}>{videoCategory}</div>
          <div className="video-view">
            {views} بازدید &nbsp;
            <FontAwesomeIcon icon={faCalendarAlt} /> {timeAgo}
          </div>
        </div>
      </div>
    </>
  );
};

export default VideoCardList;
